module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA0BAMAAABvKZXBAAAALVBMVEVHcEzMzMzMzMzMzMzNzc3MzMzMzMzNzc3MzMzMzMzLy8vNzc3MzMzNzc3MzMy1kQ7RAAAADnRSTlMA7fg4SYVZbd4cKxK5m8p/aLEAAADISURBVCjPY2BAB5wTULjc596gCPC+e9eJzGd89+4FsgKOd6gK2IH8FwuQBOKAAl1IfFYg/yG6Aik0Ex4aIAnUAQWE8SnIAwooI/HZgPxHDmgKVJAV6KEpcAIqUEPis4AUJKApeIam4B2yAkMg/zkSn1kOKHABTcFTdAUBSAIL0RSgaUBXT0DaCdU96O5F8zC6f5NQAww9QNHCExQhjwxwRhh6fKFJoycItPTAipag0NITOL1NwJ0e0dMrenoGpvcNqBlgAwMeAAAb2arWPhPaaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiantou@2x.png
// module id = lICO
// module chunks = 1